import { Link } from "react-router";

export function NotFound() {
  return (
    <div className="page">
      <div className="page-head">
        <div>
          <div className="eyebrow">404</div>
          <h1>That page does not exist.</h1>
          <p>
            The link may be out of date, or the page may not have shipped yet.
          </p>
        </div>
      </div>
      <Link className="button primary" to="/">
        Back to results
      </Link>
    </div>
  );
}
